// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import iView from 'view-design'
import i18n from '@/locale'
import menu from './libs/menu'
import common from './libs/util.js'
import config from './libs/config.js'
import { get, post, postFormData, patch, del, exportGet } from './libs/axios'
import Viewer from 'v-viewer'
import VueClipboard from 'vue-clipboard2'
import * as echarts from 'echarts'
import * as WPS from './../static/wps/web-office-sdk-v1.1.5.es.js'
import '@/icons'
import 'view-design/dist/styles/iview.css'
import 'viewerjs/dist/viewer.css'
import '../static/fontIcon/style.css'
import './assets/myTheme.less'
import './assets/common.scss'
import my_UI from '@/components/common/index.js'
import City from './components/common/city/city.vue'
Vue.component('City', City)

import print from '@/libs/print'
Vue.use(print)

Vue.use(my_UI)

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999 // 解决图片放大的层级问题
  }
})
Vue.config.productionTip = false // 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.use(VueClipboard)

// 大数据表格
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)

Vue.prototype.$Message.config({
  duration: 3
})
Vue.prototype.wps = WPS
Vue.prototype.common = common
Vue.prototype.config = config
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$patch = patch
Vue.prototype.$del = del
Vue.prototype.$exportGet = exportGet
Vue.prototype.$postFormData = postFormData
Vue.prototype.menu = menu.menuJson
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$echarts = echarts

/* 路由的前置钩子函数 */
router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('token')
  const expiryTime = window.localStorage.getItem('expiryTime')

  if (to.matched.length === 0) {
    return next('/')
  }
  if (to.path === '/login') {
    next()
  } else if (token && expiryTime && new Date().getTime() - expiryTime < 12 * 60 * 60 * 1000) {
    next()
  } else {
    next('/login')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js